import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import { SaveButton, DeleteButton } from '../Buttons';

const Header = styled.div`
    /* display: flex;
    align-items: center;
    justify-content: space-between; */
    background: #fff;
    padding: 8px 16px;
    position: sticky;
    top: 0;
    z-index: 1;
`;

const HeaderTitle = styled.h3`
    margin-top: 0;
    margin-bottom: 8px;
`;

const ActionBar = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding: 0 16px;

    & > * {
        margin-left: 16px;
    }

    & > *:first-child {
        margin-left: 0px;
    }
`;

/**
 *
 * @param {object} props
 * @param {string | object} props.title
 * @param {{key: string, label: string, onClick: function}[]} props.actions -
 *  key: save | delete | ...
 * @returns
 */
const HeaderButtonContainer = ({ title, actions = [] }) => {
    return (
        <Header>
            {title && <HeaderTitle>{title}</HeaderTitle>}
            <ActionBar>
                {actions.map((action) => {
                    let ButtonComp;
                    switch (action.key) {
                        case 'save':
                            ButtonComp = SaveButton;
                            break;
                        case 'delete':
                            ButtonComp = (props) => (
                                <DeleteButton variant="outlined" {...props} />
                            );
                            break;
                        default:
                            ButtonComp = Button;
                    }
                    const { label, key, ...buttonProps } = action;
                    return (
                        <ButtonComp key={key} {...buttonProps}>
                            {label}
                        </ButtonComp>
                    );
                })}
            </ActionBar>
        </Header>
    );
};

export default HeaderButtonContainer;
